import React, { useState } from "react";
import { Creative } from "../../types/creative.types";

interface CreativeSelectionCardProps {
  creative: Creative;
  isSelected: boolean;
  onSelect: () => void;
}

const CreativeSelectionCard: React.FC<CreativeSelectionCardProps> = ({
  creative,
  isSelected,
  onSelect,
}) => {
  const [imageError, setImageError] = useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  const getDisplayFormat = () => {
    if (creative.imageUrl?.startsWith("data:")) {
      const match = creative.imageUrl.match(/^data:(image\/[a-zA-Z]+);base64,/);
      return match ? match[1] : "unknown";
    }

    if (creative.fileFormat) {
      return `image/${creative.fileFormat.toLowerCase()}`;
    }

    if (creative.imageUrl) {
      const urlParts = creative.imageUrl.split(".");
      const extension = urlParts[urlParts.length - 1]
        .split("?")[0]
        .toLowerCase();
      return `image/${extension}`;
    }

    return "unknown";
  };

  return (
    <div
      className={`w-full h-[250px] 2xl:h-[260px]  3xl:h-[260px] 4xl:h-[250px]  5xl:h-[280px] bg-white rounded-[16px] shadow-md overflow-hidden transition-all cursor-pointer relative ${
        isSelected
          ? "shadow-[0_4px_20px_rgba(0,0,0,0.15)]"
          : "shadow-[0_2px_10px_rgba(0,0,0,0.05)] hover:shadow-[0_4px_20px_rgba(0,0,0,0.1)]"
      }`}
      onClick={onSelect}
    >
      <div className="relative w-full h-[180px] 2xl:h-[190px] 3xl:h-[190px] 4xl:h-[180px] 5xl:h-[210px] bg-gradient-to-br from-[#0BA6C7]/10 to-[#0BA6C7]/20 rounded-t-[16px] flex items-center justify-center overflow-hidden">
        {!imageError ? (
          <img
            src={creative.imageUrl}
            alt="Creative Thumbnail"
            className="max-w-full max-h-full object-contain transition-opacity duration-300"
            onError={handleImageError}
            style={{
              filter: "drop-shadow(0 2px 8px rgba(0,0,0,0.1))",
            }}
          />
        ) : (
          <div className="flex flex-col items-center justify-center text-gray-400">
            <svg
              className="w-12 h-12 mb-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span className="text-xs">Image not available</span>
          </div>
        )}
      </div>

      <div className="px-4 py-3">
        <div
          className="text-black text-base font-semibold mb-2 truncate"
          title={creative.title}
        >
          {creative.title}
        </div>
        <div className="text-black text-xs font-medium truncate">
          {getDisplayFormat()}
        </div>
      </div>
    </div>
  );
};

export default CreativeSelectionCard;
